import { IngestionPlatform } from '@client/graphql/__generated__/types';

/**
 * Format platform name for display
 * Capitalizes first letter and lowercases the rest
 */
export const formatPlatformName = (platform: IngestionPlatform): string => {
  return platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase();
};
